/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * A React component for closed caption icon.
 *
 * @author Ramani Govindaraju
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ClosedCaption = props => (
  <SvgIcon
    fillRule="evenodd"
    stroke="#FFF"
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      d="M17.625 13.375h-9l-3 3v-3H.375v-12h17.25zM4.125
      5.125h6.75M4.125 7.375h9.75M4.125 9.625h9.75"
    />
  </SvgIcon>
);

export default ClosedCaption;



// WEBPACK FOOTER //
// ./src/js/icons/ClosedCaption.jsx